<script lang="ts">
    import { appManager } from "../AppManagerStore";

    import { useLocation, useNavigate } from "svelte-navigator";
    const navigate = useNavigate();

    async function signOut() {
        const result = await $appManager.IdentityApi.logout();
        await $appManager.Authenticator.logout();

        window.location.href = `${$appManager.PublicUrl}`;
    }
</script>

{#await signOut()}
    <div />
{/await}
